import React, { useEffect, useState } from 'react';
import SEO from '../components/SEO';
import '../App.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 150;
        
        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('animate');
        }
      });
    };

    setTimeout(() => {
      handleScroll();
    }, 100);
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to a server
    alert('धन्यवाद! हम जल्द ही आपसे संपर्क करेंगे।');
    setFormData({ name: '', phone: '', email: '', message: '' });
  };

  return (
    <div className="App">
      <SEO
        title="Contact - Best Nasha Mukti in Patna & Bihar | Nihansh Foundation"
        description="Contact Nihansh Foundation - Best Nasha Mukti in Patna, Bihar. Call +91 6202410010 for 24/7 Nasha Mukti Kendra assistance."
        path="/contact"
      />
      {/* Contact Hero */}
      <section className="page-hero contact-hero">
        <div className="page-hero-background">
          <div className="page-hero-overlay"></div>
        </div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">संपर्क करें</h1>
          <p className="page-hero-subtitle">हमसे संपर्क करें और नशामुक्त जीवन की यात्रा शुरू करें</p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-page">
        <div className="container">
          <div className="contact-page-grid">
            {/* Contact Form */}
            <div className="contact-form-wrapper animate-on-scroll">
              <h2 className="contact-form-title">हमें संदेश भेजें</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">आपका नाम *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="अपना नाम दर्ज करें"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">फोन नंबर *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="अपना फोन नंबर दर्ज करें"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">ईमेल</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="अपना ईमेल दर्ज करें"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="message">संदेश *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="अपना संदेश यहाँ लिखें"
                  ></textarea>
                </div>
                <button type="submit" className="submit-button">
                  संदेश भेजें
                </button>
                <div className="contact-form-images-grid">
                  <div className="contact-form-image">
                    <img 
                      src="/images/02.jpeg" 
                      alt="Nihansh Foundation" 
                      className="contact-form-img"
                    />
                  </div>
                  <div className="contact-form-image">
                    <img 
                      src="/images/04.jpeg" 
                      alt="Nihansh Foundation" 
                      className="contact-form-img"
                    />
                  </div>
                </div>
              </form>
            </div>

            {/* Contact Info */}
            <div className="contact-info-wrapper animate-on-scroll">
              <h2 className="contact-info-title">संपर्क जानकारी</h2>
              <div className="contact-info-cards">
                <div className="contact-info-card">
                  <div className="contact-info-icon">📍</div>
                  <h3 className="contact-info-card-title">पता</h3>
                  <p className="contact-info-text">
                    Krishna Niketan, School Road<br />
                    Near Bajrangi Chowk, Jakariyapur<br />
                    Zero Mile, Pahari, Patna, Bihar 800030<br />
                    India
                  </p>
                </div>
                <div className="contact-info-card">
                  <div className="contact-info-icon">📞</div>
                  <h3 className="contact-info-card-title">फोन</h3>
                  <p className="contact-info-text">
                    <a href="tel:+916202410010">+91 6202410010</a>
                  </p>
                </div>
                <div className="contact-info-card">
                  <div className="contact-info-icon">✉️</div>
                  <h3 className="contact-info-card-title">ईमेल</h3>
                  <p className="contact-info-text">
                    <a href="mailto:nihanshfoundation@gmail.com">nihanshfoundation@gmail.com</a>
                  </p>
                </div>
                <div className="contact-info-card">
                  <div className="contact-info-icon">🕐</div>
                  <h3 className="contact-info-card-title">कार्य समय</h3>
                  <p className="contact-info-text">
                    सोमवार - रविवार<br />
                    24/7 उपलब्ध
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google Map Section */}
      <section className="map-section">
        <div className="container">
          <h2 className="section-title animate-on-scroll">हमारा स्थान</h2>
          <p className="section-subtitle animate-on-scroll">हमारे केंद्र का पता खोजें</p>
          <div className="map-wrapper animate-on-scroll">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3599.2435780281214!2d85.17808042346827!3d25.5813031!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f2a70485e4f85f%3A0xdb75cf2222f15636!2sNihansh%20Foundation!5e0!3m2!1sen!2sin!4v1703691234567&z=15"
              width="100%"
              height="450"
              style={{ border: 0, borderRadius: '16px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Nihansh Foundation Location"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Emergency CTA */}
      <section className="emergency-cta">
        <div className="container">
          <div className="emergency-cta-content animate-on-scroll">
            <h2 className="emergency-title">आपातकालीन सहायता</h2>
            <p className="emergency-text">
              यदि आपको तत्काल सहायता की आवश्यकता है, तो कृपया हमें तुरंत कॉल करें
            </p>
            <a href="tel:+916202410010" className="emergency-button">
              अभी कॉल करें: +91 6202410010
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;

